import { apiClient } from '@/lib/api-client';

export type CashSessionStatus = 'OPEN' | 'CLOSED';

export interface CashSession {
  id: string;
  tenantId: string;
  userId: string;
  openedAt: string;
  closedAt: string | null;
  openingFloat: string;
  declaredCash: string | null;
  expectedCash: string | null;
  cashDifference: string | null;
  notes: string | null;
  status: CashSessionStatus;
}

export interface CashSessionSummary {
  session: CashSession;
  salesCount: number;
  salesTotal: string;
  paymentsByMethod: Array<{
    method: string;
    count: number;
    amount: string;
    changeGiven: string;
  }>;
  expectedCash: string;
}

export async function getCurrentSession(): Promise<CashSession | null> {
  const { data } = await apiClient.get<CashSession | null>('/cash-sessions/current');
  return data;
}

export async function listSessions(): Promise<CashSession[]> {
  const { data } = await apiClient.get<CashSession[]>('/cash-sessions');
  return data;
}

export async function getSessionSummary(id: string): Promise<CashSessionSummary> {
  const { data } = await apiClient.get<CashSessionSummary>(`/cash-sessions/${id}/summary`);
  return data;
}

export async function openSession(input: {
  openingFloat: number;
  notes?: string;
}): Promise<CashSession> {
  const { data } = await apiClient.post<CashSession>('/cash-sessions/open', input);
  return data;
}

export async function closeSession(
  id: string,
  input: { declaredCash: number; notes?: string },
): Promise<CashSession> {
  const { data } = await apiClient.post<CashSession>(`/cash-sessions/${id}/close`, input);
  return data;
}
